import { render, staticRenderFns } from "./SetUpMyAvatar.vue?vue&type=template&id=75ef0d05&scoped=true&"
import script from "./SetUpMyAvatar.vue?vue&type=script&lang=js&"
export * from "./SetUpMyAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SetUpMyAvatar.vue?vue&type=style&index=0&id=75ef0d05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef0d05",
  null
  
)

export default component.exports